import { useQuery } from 'react-query';
import { QueryKeys } from 'api/queryKeys';
import { network } from 'services/network';
import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { NarrativeRequest } from 'utilitys/narrative/narrativeTools';

const queryFn = (params: QueryParams): Promise<QueryResponse> => {
    return network.post('api/bo/getProgressScurveGraph', params).then((response) => {
        return response.data;
    });
};

export const useQueryGetCriticalityWeightScurveGraph = (params: QueryParams) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, (QueryKeys | QueryParams)[]>({
        queryKey: ['getProgressScurveGraph', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.actualMetaDataId && params.baselineMetaDataId && params.graphType),
    });
};

interface Data {
    text: string;
    label: number;
    value: number;
}

interface GraphLine {
    title: string | null;
    seriesname: null;
    data: Data[];
}

export interface QueryResponse {
    nowDate: string;
    plannedGraphLine: GraphLine;
    actualGraphLine: GraphLine;
    forecatsGraphLine: GraphLine;
    info: IToolTip;
}

interface QueryParams extends NarrativeRequest {
    actualMetaDataId: number | undefined;
    baselineMetaDataId: number | undefined;
    graphType: string;
    isPartialCompletion: string;
    filter: {
        filters: IFilter[] | undefined;
    };
}
